import { get, writable } from 'svelte/store';
import { getCasinos } from '../controllers/APIController';


const casinosStore = () => {
  	
	const { subscribe, set, update } = writable([]);
	
    const methods = {
        async fetchCasinos () {
            const res = await getCasinos();
            let validCasinos = [];
            for (let casino of res.casinos)
                if (casino.id_ == 61 || casino.id_ == 62)   //limit to these 3 casinos only
                {
                    validCasinos.push(casino);
                    if (validCasinos.length >= 3)
                        break;
                }

            set(validCasinos);
            return validCasinos;
        },

        async getCasinoById(casinoId) {
            let casinos = get(this);
            if (!casinos || !casinos.length)
                casinos = await this.fetchCasinos();    //fetch casinos if not available yet

            for (let i in casinos)
                if (casinos[i].id_ == casinoId)
                    return casinos[i];

            return null;
        }
    }

    return {
        subscribe,
        ...methods
    }
}

export default casinosStore();